import React from "react";
import AccountSidebar from "../../components/Account/SIdebar";

const MyAddress = () => {
  return (
    <>
      <section className="account-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="account-data">
                <AccountSidebar />
                  <div className="dashboard">
                    <h4>Address </h4>
                    <p>
                      From your account dashboard. you can easily check &amp;
                      view your recent orders, manage your shipping and billing addresses and
                      Edit your password and account details.
                    </p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyAddress;
